module.exports = __webpack_public_path__ + "static/media/playlist.40b4903e.svg";